import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AppSidebar } from "./AppSidebar";
import { ConversationSidebar } from "@/components/Conversation/ConversationSidebar";
import { TabLoadingState } from "@/components/LoadingStates";
import { useTabNavigation } from "@/contexts/AppStateContext";

const Layout: React.FC = () => {
  const location = useLocation();
  const { isNavigating } = useTabNavigation();

  // Determine if conversation sidebar should be shown
  const showConversationSidebar = location.pathname === '/query-generator';

  // Map route paths to tab names
  const getTabName = (pathname: string) => {
    switch (pathname) {
      case '/query-generator': return 'Query Generator';
      case '/connections': return 'Database Connections';
      case '/golden-sqls': return 'Golden SQLs';
      case '/instructions': return 'Instructions';
      case '/pricing': return 'Pricing';
      case '/help': return 'Help';
      case '/profile': return 'Profile';
      default: return 'Dashboard';
    }
  };

  const currentTabName = getTabName(location.pathname);

  return (
    <div className="flex h-screen overflow-hidden bg-[#ebebf0]">
      {/* App Sidebar (Left Navigation) */}
      <AppSidebar />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden p-2 pl-0">
        <div className="bg-[#fcfcfd] rounded shadow-[0px_1px_4px_0px_rgba(20,20,20,0.15)] flex-1 flex flex-col overflow-hidden">
          <div className="flex flex-1 overflow-hidden">
            {/* Conversation Sidebar (Chat History) - Only on chat pages */}
            {showConversationSidebar && <ConversationSidebar />}

            {/* Main Content */}
            <main className="flex-1 overflow-y-auto overflow-x-hidden custom-scrollbar">
              {isNavigating ? (
                <div className="h-full flex items-center justify-center">
                  <TabLoadingState
                    tabName={currentTabName}
                    message={`Loading ${currentTabName}...`}
                  />
                </div>
              ) : (
                <Outlet />
              )}
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
